import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a70966f8295d50014940e97_1786106669755_c3292ed8/eventify/src/app/forgot-password/page.tsx");
